import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { CLINICS } from '../../constant';

interface Payload {
  id: string;
}

export const deleteDropdownSettingApi = createAsyncThunk(
  'dropdownSettings/delete',
  async (payload: Payload, { rejectWithValue }) => {
    try {
      const requestOptions = {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + getToken(),
        },
      };

      const url = `${CLINICS.DROPDOWN_SETTINGS_URL}?id=${encodeURIComponent(payload.id)}`;
      const res = await fetch(url, requestOptions);

      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        return rejectWithValue(errorData.msg || 'Failed to delete dropdown');
      }

      const data = await res.json();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
